import React from "react";
import { useNavigate, Link } from "react-router-dom";

interface HeaderLandingProps {
  onTryFree?: () => void;
  onLogin?: () => void;
  // Opcional: si quieres ocultar el botón de login cuando ya estás en la página de login
  showLoginButton?: boolean;
}

export const HeaderLanding: React.FC<HeaderLandingProps> = ({
  onTryFree,
  onLogin,
  showLoginButton = true,
}) => {
  const navigate = useNavigate();

  // Manejadores por defecto si no se pasan props
  const handleTryFreeDefault = () => {
    if (onTryFree) {
      onTryFree();
    } else {
      navigate("/#register");
    }
  };

  const handleLoginDefault = () => {
    if (onLogin) {
      onLogin();
    } else {
      navigate("/login");
    }
  };

  const goHome = () => navigate("/");

  return (
    <header>
      <div className="container">
        <nav className="navbar">
          {/* Logo con navegación al home */}
          <div className="logo" onClick={goHome} style={{ cursor: "pointer" }}>
            <img
              src="logo_resized.jpg"
              alt="Cara de agenda"
              className="logo-img"
            />
            <h3>Cara de agenda</h3>
          </div>

          {/* Mobile Navigation */}
          <div className="mobile-nav-buttons">
            {showLoginButton && (
              <button
                onClick={handleLoginDefault}
                className="btn btn--secondary btn--small-mobile"
              >
                Iniciar Sesión
              </button>
            )}
            <button
              onClick={handleTryFreeDefault}
              className="btn btn--primary button_try btn--small-mobile"
            >
              Prueba Gratuita
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};
